import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  TextField,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alerter,
  Chip,
  Paper,
  Divider,
  Switch,
  FormControlLabel,
  Snackbar,
  Portal,
  CircularProgress,
} from '@mui/material';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
// import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

import {
  PlayArrow as PlayIcon,
  Pause as PauseIcon,
  Stop as StopIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  School as SchoolIcon,
  Timer as TimerIcon,
  Notifications as NotificationsIcon,
} from '@mui/icons-material';
import Snack from './snack';
import MuiAlert from '@mui/material/Alert';

import axios from "axios"
import { schooldetails } from './redux/schooldetails';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';


import Assembly from './sound/assembly.mp3';
import Break from './sound/break.mp3';
import Breakover from './sound/breakover.mp3';
import Change from './sound/change.mp3';
import Change2 from './sound/change2.mp3';
import Brahms from './sound/brahmsx27-lullaby-160672.mp3';
import Calm from './sound/calm-and-peaceful-115481.mp3';
import Closing from './sound/closing.mp3';
import Lunch from './sound/lunch.mp3';
import Twinkle from './sound/twinkle-like-a-star-8026.mp3';
import Madieval from './sound/medieval-star-188280.mp3';
import Lunchover from './sound/lunchover.mp3';
import Storybook from './sound/lullaby-storybook-2-317191.mp3';
import Sleep from './sound/lullaby-sleep-piano-music-285599.mp3';
import Fairies from './sound/lullaby-fairies-315868.mp3';
import Baby from './sound/lullaby-baby-sleep-dreams-celestial-music-297507.mp3';
import Legacy from './sound/legacy-of-brahms-lullaby-background-orchestral-music-for-video-full-274550.mp3';
import Deck from './sound/deck-the-halls-background-christmas-music-for-video-calesta-version-253224.mp3';
import NSMQ from './sound/NSMQ.mp3';

const Alarmlist = [
  // {type:"assembly", alarm:Assembly},
  // {type:"break", alarm:Break},
  // {type:"breakover", alarm:Breakover},
  // {type:"change", alarm:Change},
  // {type:"change2", alarm:Change2},
  {type:"brahms", alarm:Brahms},
  {type:"calm", alarm:Calm},
  {type:"NSMQ", alarm:NSMQ},
  // {type:"closing", alarm:Closing},
  // {type:"lunch", alarm:Lunch},
  {type:"twinkle", alarm:Twinkle},
  {type:"madieval", alarm:Madieval},
  // {type:"lunchover", alarm:Lunchover},
  {type:"storybook", alarm:Storybook},
  {type:"sleep", alarm:Sleep},
  {type:"fairies", alarm:Fairies},
  {type:"baby", alarm:Baby},
  {type:"legacy", alarm:Legacy},
  {type:"deck", alarm:Deck},
]


const Alarmlist2 = [
  // {type:"assembly", alarm:Assembly},
  {type:"break", alarm:Break},
  {type:"breakover", alarm:Breakover},
  {type:"change", alarm:Change},
  {type:"change2", alarm:Change2},
  {type:"brahms", alarm:Brahms},
  {type:"calm", alarm:Calm},
  {type:"NSMQ", alarm:NSMQ},
  {type:"closing", alarm:Closing},
  {type:"lunch", alarm:Lunch},
  {type:"twinkle", alarm:Twinkle},
  {type:"madieval", alarm:Madieval},
  {type:"lunchover", alarm:Lunchover},
  {type:"storybook", alarm:Storybook},
  {type:"sleep", alarm:Sleep},
  {type:"fairies", alarm:Fairies},
  {type:"baby", alarm:Baby},
  {type:"legacy", alarm:Legacy},
  {type:"deck", alarm:Deck},
]


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const soundTypes = [
  { id: 'bell', name: 'School Bell' },
  { id: 'chime', name: 'Gentle Chime' },
  { id: 'gong', name: 'Gong' },
  { id: 'whistle', name: 'Whistle' },
];

// Mock data for demonstration
const mockSchedule = [
  {
    id: 1,
    name: 'Morning Assembly',
    time: '08:00',
    type: 'assembly',
    sound: 'bell',
    isActive: true,
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
  },
  {
    id: 2,
    name: 'First Period',
    time: '08:30',
    type: 'class',
    sound: 'bell',
    isActive: true,
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
  },
  {
    id: 3,
    name: 'Break Time',
    time: '09:15',
    type: 'break',
    sound: 'bell',
    isActive: true,
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
  },
];

export default function SchoolBellSystem() {
  // Initialize state from localStorage
  const dispatch = useDispatch()
  const admin = useSelector((state) => state.admin)

  const schooldetails_ = useSelector((state) => state.schooldetails)
  const [schedule, setSchedule] = useState(schooldetails_[0] && schooldetails_[0].siren ? schooldetails_[0].siren : [])
  
  // Sync local schedule state with Redux when schooldetails_ changes
  useEffect(() => {
    if (schooldetails_ && schooldetails_.length > 0 && schooldetails_[0].siren) {
      setSchedule(schooldetails_[0].siren);
    }
  }, [schooldetails_]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    time: '',
    type: 'class',
    sound: 'bell',
    isActive: true,
    days: [],
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const audioContextRef = useRef(null);
  const [nextEvent, setNextEvent] = useState(null);
  const [showFloatingNotification, setShowFloatingNotification] = useState(true);
  const [opensnack, setOpensnack] = React.useState(false);
  const [message, setmessage] = React.useState("");
  const [stated, setstated] = React.useState("");
  const [personName, setPersonName] = React.useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Reference to store the current Audio object
  const audioRef = useRef(null);
  // State to track which audio is playing (null if none)
  const [currentPlaying, setCurrentPlaying] = useState(null);

  // Function to play an audio file
  const playAudio = (alarm, type) => {
    // Stop any currently playing audio
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
      setCurrentPlaying(null);
    }

    try {
      // Create a new Audio object
      const audio = new Audio(alarm);
      audioRef.current = audio;
      setCurrentPlaying(type);

      // Play the audio
      audio.play().catch((error) => {
        console.error(`Error playing audio (${type}):`, error);
      });

      // Reset state when audio ends
      audio.onended = () => {
        setCurrentPlaying(null);
        audioRef.current = null;
      };
    } catch (error) {
      console.error(`Error setting up audio (${type}):`, error);
    }
  };

  // Function to stop the current audio
  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
      setCurrentPlaying(null);
    }
  };





  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    const selectedDays = typeof value === 'string' ? value.split(',') : value;
    
    setPersonName(selectedDays);
    setFormData({ ...formData, days: selectedDays });
  };


  // Timer effect
  useEffect(() => {
    let timer;
    if (isPlaying) {
      timer = setInterval(() => {
        setCurrentTime(new Date());
        checkAndPlayEvents();
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isPlaying]);

  const checkAndPlayEvents = () => {
    const currentTimeStr = currentTime.toLocaleTimeString('en-US', { 
      hour12: false, 
      hour: '2-digit', 
      minute: '2-digit',
      second: '2-digit'
    });
    const currentDay = currentTime.toLocaleDateString('en-US', { weekday: 'long' });


    schedule.forEach(event => {
      // Add seconds to event time for comparison
      const eventTimeWithSeconds = `${event.time}:00`;
      
      if (event.isActive && 
          event.days.includes(currentDay) && 
          eventTimeWithSeconds === currentTimeStr) {
        generateDummySound(event.sound);
      }
    });
  };

  const handleOpenDialog = (event = null) => {
    if (event) {
      setSelectedEvent(event);
      setFormData({
        name: event.name,
        time: event.time,
        type: event.type,
        sound: event.sound,
        isActive: event.isActive,
        days: event.days,
      });
      setPersonName(event.days || []); // Set personName for editing
    } else {
      setSelectedEvent(null);
      setFormData({
        name: '',
        time: '',
        type: 'class',
        sound: 'bell',
        isActive: true,
        days: [],
      });
      setPersonName([]); // Reset personName for new event
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedEvent(null);
    setFormData({
      name: '',
      time: '',
      type: 'class',
      sound: 'bell',
      isActive: true,
      days: [],
    });
    setPersonName([]); // Reset personName when closing dialog
  };

  const getEventColor = (type) => {
    switch (type) {
      case 'assembly':
        return 'primary';
      case 'change':
        return 'success';
      case 'break':
        return 'warning';
      default:
        return 'default';
    }
  };

  const handleSubmit = () => {
    if (!formData.name || !formData.time) {
      setError('Please fill in all required fields');
      setOpensnack(true);
      setmessage("Please fill in all required fields");
      setstated("error");
      return;
    }

    setIsSubmitting(true); // Start loading

    const newEvent = {
      id: selectedEvent ? selectedEvent.id : Date.now(),
      ...formData,
    };

    if (selectedEvent) {
      setSchedule(schedule.map(event => 
        event.id === selectedEvent.id ? newEvent : event
      ));

      // Edit existing event
      const schooldata = async () => {
        try {
          const response = await axios.post("https://servermain.sisrevolution.com/api/schools/editsiren/",
            {
              schoolID: admin.schoolID,
              siren: newEvent,
              sirenid: newEvent.id
            });

          if (response.status === 200) {
            // Update Redux with the new siren data
            const updatedSchoolData = response.data.length !== 1 ? response.data : [response.data];
            dispatch(schooldetails({
              data: updatedSchoolData
            }));
            
            // Show success notification
            setOpensnack(true);
            setmessage("Schedule event updated successfully");
            setstated("success");
            handleCloseDialog();
          }
        } catch (error) {
          console.error('Error updating event:', error);
          setOpensnack(true);
          setmessage("Failed to update schedule event");
          setstated("error");
        } finally {
          setIsSubmitting(false); // Stop loading regardless of outcome
        }
      };

      schooldata();
    } else {
      // Add new event
      setSchedule([...schedule, newEvent].sort((a, b) => a.time.localeCompare(b.time)));

      const schooldata = async () => {
        try {
          const response = await axios.post("https://servermain.sisrevolution.com/api/schools/addsiren/",
            {
              schoolID: admin.schoolID,
              siren: newEvent,
              sirenid: newEvent.id
            });

          if (response.status === 200) {
            // Update Redux with the new siren data
            dispatch(schooldetails({
              data: [response.data]
            }));
            
            // Show success notification
            setOpensnack(true);
            setmessage("New schedule event added successfully");
            setstated("success");
            handleCloseDialog();
          }
        } catch (error) {
          console.error('Error adding event:', error);
          setOpensnack(true);
          setmessage("Failed to add new schedule event");
          setstated("error");
        } finally {
          setIsSubmitting(false); // Stop loading regardless of outcome
        }
      };

      schooldata();
    }
  };

  // Initialize Web Audio API after user interaction
  const initializeAudioContext = () => {
    if (!audioContextRef.current) {
      try {
        if (typeof window !== 'undefined') {
          const AudioContext = window.AudioContext || window.webkitAudioContext;
          if (AudioContext) {
            const ctx = new AudioContext();
            audioContextRef.current = ctx;
          } else {
            console.warn('Web Audio API is not supported in this browser');
          }
        }
      } catch (error) {
        console.error('Error initializing AudioContext:', error);
      }
    }
  };

  const generateDummySound = (soundType) => {
    if (!audioContextRef.current) {
      console.warn('AudioContext not initialized');
      return;
    }

    try {
      const ctx = audioContextRef.current;
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();

      // Configure sound based on type
      switch (soundType) {
        case 'bell':
          oscillator.type = 'sine';
          oscillator.frequency.setValueAtTime(880, ctx.currentTime); // A5 note
          gainNode.gain.setValueAtTime(0.5, ctx.currentTime);
          gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 1);
          oscillator.connect(gainNode);
          gainNode.connect(ctx.destination);
          oscillator.start();
          oscillator.stop(ctx.currentTime + 1);
          break;
        case 'chime':
          oscillator.type = 'sine';
          oscillator.frequency.setValueAtTime(440, ctx.currentTime); // A4 note
          gainNode.gain.setValueAtTime(0.3, ctx.currentTime);
          gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.5);
          oscillator.connect(gainNode);
          gainNode.connect(ctx.destination);
          oscillator.start();
          oscillator.stop(ctx.currentTime + 0.5);
          break;
        case 'gong':
          oscillator.type = 'triangle';
          oscillator.frequency.setValueAtTime(220, ctx.currentTime); // A3 note
          gainNode.gain.setValueAtTime(0.4, ctx.currentTime);
          gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 2);
          oscillator.connect(gainNode);
          gainNode.connect(ctx.destination);
          oscillator.start();
          oscillator.stop(ctx.currentTime + 2);
          break;
        case 'whistle':
          oscillator.type = 'sine';
          oscillator.frequency.setValueAtTime(1760, ctx.currentTime); // A6 note
          gainNode.gain.setValueAtTime(0.2, ctx.currentTime);
          gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3);
          oscillator.connect(gainNode);
          gainNode.connect(ctx.destination);
          oscillator.start();
          oscillator.stop(ctx.currentTime + 0.3);
          break;
        default:
          // Default to bell sound if soundType is not recognized
          oscillator.type = 'sine';
          oscillator.frequency.setValueAtTime(880, ctx.currentTime); // A5 note
          gainNode.gain.setValueAtTime(0.5, ctx.currentTime);
          gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 1);
          oscillator.connect(gainNode);
          gainNode.connect(ctx.destination);
          oscillator.start();
          oscillator.stop(ctx.currentTime + 1);
          break;
      }
    } catch (error) {
      console.error('Error generating sound:', error);
    }
  };

  const handleToggleActive = (id) => {
    // First update the local state
    const updatedSchedule = schedule.map(event => 
      event.id === id ? { ...event, isActive: !event.isActive } : event
    );
    setSchedule(updatedSchedule);

    // Find the updated event
    const updatedEvent = updatedSchedule.find(event => event.id === id);

    // Update backend database
    const updateAlarmStatus = async () => {
      try {
        const response = await axios.post("https://servermain.sisrevolution.com/api/schools/editsiren/", {
          schoolID: admin.schoolID,
          siren: updatedEvent,
          sirenid: id
        });
       
        if (response.status === 200) {
          // Update Redux with the updated siren data
          const updatedSchoolData = response.data.length !== 1 ? response.data : [response.data];
          dispatch(schooldetails({
            data: updatedSchoolData
          }));
          
          // Show success notification
          setOpensnack(true);
          setmessage(`Alarm ${updatedEvent.isActive ? 'activated' : 'deactivated'} successfully`);
          setstated("success");
        }
      } catch (error) {
        console.error('Error updating alarm status:', error);
        // Show error notification
        setOpensnack(true);
        setmessage("Failed to update alarm status");
        setstated("error");
        
        // Revert the local state change on error
        setSchedule(schedule);
      }
    };

    updateAlarmStatus();
  };

  const handleDeleteEvent = (id) => {
    // Get the updated schedule after filtering
    const updatedSchedule = schedule.filter(event => event.id !== id);
    setSchedule(updatedSchedule);
    // delete here

    const schooldata= async () => {
      await axios.post("https://servermain.sisrevolution.com/api/schools/deletesiren/",
          {
              schoolID:admin.schoolID,
              siren:updatedSchedule,
              // sirenid:newEvent.id

          }).then(res => {
              if (res.status === 200) {
                // Update Redux with the updated siren data after deletion
                const updatedSchoolData = res.data.length !== 1 ? res.data : [res.data];
                dispatch(schooldetails({
                  data: updatedSchoolData
                }));


              }

          })

  }

  schooldata()

    


  };

  // Function to find the next upcoming event
  const findNextEvent = () => {
    const now = new Date();
    const currentTimeStr = now.toLocaleTimeString('en-US', { 
      hour12: false, 
      hour: '2-digit', 
      minute: '2-digit',
      second: '2-digit'
    });
    const currentDay = now.toLocaleDateString('en-US', { weekday: 'long' });

    // Filter active events for today
    const todayEvents = schedule.filter(event => 
      event.isActive && 
      event.days.includes(currentDay) &&
      event.time > currentTimeStr
    );

    // Sort by time and get the next event
    const nextEvent = todayEvents.sort((a, b) => a.time.localeCompare(b.time))[0];
    setNextEvent(nextEvent);
  };

  // Update next event when schedule changes or time updates
  useEffect(() => {
    if (isPlaying) {
      findNextEvent();
    }
  }, [schedule, currentTime, isPlaying]);

  // Save schedule to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('sirenSchedule', JSON.stringify(schedule));
  }, [schedule]);


    const handleClicksnack = () => {
        setOpensnack(true);
    };

      
    const handleClosesnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpensnack(false);
    };


    const names = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']












  return (
    <Box sx={{ p: 4 }}>

     <Snackbar open={opensnack} autoHideDuration={6000} onClose={handleClosesnack}>
                <Alert onClose={handleClosesnack} severity={stated} sx={{ width: '100%' }}>
                    { message }
                </Alert>
            </Snackbar>
      <Grid container spacing={3}>
        {/* Control Panel */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <Button
                  variant="contained"
                  color={isPlaying ? 'warning' : 'success'}
                  startIcon={isPlaying ? <PauseIcon /> : <PlayIcon />}
                  onClick={() => {
                    if (!audioContextRef.current) {
                      initializeAudioContext();
                    }
                    setIsPlaying(!isPlaying);
                  }}
                >
                  {isPlaying ? 'Pause System' : 'Start System'}
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<StopIcon />}
                  onClick={() => {
                    setIsPlaying(false);
                    setCurrentTime(new Date());
                  }}
                >
                  Reset Time
                </Button>
                <Typography variant="h6" sx={{ ml: 'auto' }}>
                  Current Time: {currentTime.toLocaleTimeString()}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Schedule List */}
        <Grid item xs={12} md={8}>
          <Card>
            <CardHeader
              title="Schedule"
              subheader="School day events"
              action={
                <Button
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog()}
                >
                  Add Event
                </Button>
              }
            />
            <CardContent>
              {schedule.length === 0 ? (
                <Typography color="text.secondary" align="center">
                  No schedule events
                </Typography>
              ) : (
                <List>
                  {schedule.map((event) => (
                    <React.Fragment key={event.id}>
                      <ListItem>
                        <ListItemText
                          primary={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Typography variant="subtitle1">
                                {event.name}
                              </Typography>
                              <Chip
                                label={event.type}
                                color={getEventColor(event.type)}
                                size="small"
                              />
                              <Chip
                                label={event.sound}
                                size="small"
                                variant="outlined"
                              />
                            </Box>
                          }
                          secondary={
                            <>
                              <Typography variant="body2" color="text.secondary">
                                Time: {event.time}
                              </Typography>
                              <Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                {event.days.map((day) => (
                                  <Chip
                                    key={day}
                                    label={day}
                                    size="small"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            </>
                          }
                        />
                        <ListItemSecondaryAction>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={event.isActive}
                                onChange={() => handleToggleActive(event.id)}
                              />
                            }
                            label="Active"
                          />
                          <IconButton
                            edge="end"
                            onClick={() => handleOpenDialog(event)}
                            sx={{ mr: 1 }}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            edge="end"
                            onClick={() => handleDeleteEvent(event.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Quick Actions */}
        <Grid item xs={12} md={4}>
          <Card>
            <CardHeader
              title="Quick Actions"
              subheader="Test sounds and manage system"
            />
            <CardContent>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {/* {soundTypes.map((sound) => (
                  <Button
                    key={sound.id}
                    variant="outlined"
                    startIcon={<TimerIcon />}
                    onClick={() => {
                      if (!audioContextRef.current) {
                        initializeAudioContext();
                      }
                      generateDummySound(sound.id);
                    }}
                  >
                    Test {sound.name}
                  </Button>
                ))} */}





<div style={{ padding: '10px', marginTop:"-30px" }}>
      {/* <h1>Audio Player</h1> */}
      <div>
        {Alarmlist2.map(({ type, alarm }) => (
          <div
            key={type}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '10px',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
            }}
          >
            <span style={{ flex: 1, textTransform: 'capitalize' }}>{type}</span>
            <button
              onClick={() => playAudio(alarm, type)}
              disabled={currentPlaying === type}
              style={{
                marginRight: '10px',
                padding: '5px 10px',
                backgroundColor: currentPlaying === type ? '#ccc' : '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '3px',
                cursor: currentPlaying === type ? 'not-allowed' : 'pointer',
              }}
            >
              Play
            </button>
            <button
              onClick={stopAudio}
              disabled={currentPlaying !== type}
              style={{
                padding: '5px 10px',
                backgroundColor: currentPlaying !== type ? '#ccc' : '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '3px',
                cursor: currentPlaying !== type ? 'not-allowed' : 'pointer',
              }}
            >
              Stop
            </button>
          </div>
        ))}
      </div>
    </div>





              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          {selectedEvent ? 'Edit Schedule Event' : 'New Schedule Event'}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <TextField
              label="Event Name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              fullWidth
              required
            />
            <TextField
              label="Time"
              type="time"
              value={formData.time}
              onChange={(e) => setFormData({ ...formData, time: e.target.value })}
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              select
              label="Event Type"
              value={formData.type}
              onChange={(e) => setFormData({ ...formData, type: e.target.value })}
              fullWidth
              required
              SelectProps={{
                native: true,
              }}
            >
              <option value="" disabled>Select Event Type</option>
              <option value="change">Change Lesson</option>
              <option value="break">Break Time</option>
              <option value="startlesson">Start Lesson</option>
              <option value="silencehour">Silence Hour</option>
              <option value="remedial">Remedial</option>
              <option value="breakover">Break Over</option>
              <option value="lunch">Lunch Time</option>
              <option value="lunchover">Lunch Over</option>
              <option value="closing">Closing Time</option>
              <option value="assembly">Assembly Time</option>
              <option value="breaklower">Break Time For Lower Primary</option>
              <option value="breakupper">Break Time For Upper Primary</option>
              <option value="breakjhs">Break Time For JHS</option>
              <option value="changelessonjhs">Change lesson For JHS</option>
              <option value="changelessonlower">Change lesson For Lower Primary</option>
              <option value="changelessonupper">Change lesson For Upper Primary</option>
              <option value="lunchjhs">Lunch Time For JHS</option>
              <option value="lunchlower">Lunch Time For Lower Primary</option>
              <option value="lunchupper">Lunch Time For Upper Primary</option>
             
        
            </TextField>

            <FormControl fullWidth>
        <InputLabel id="demo-multiple-checkbox-label">Day(s)</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput label="Day(s)" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={personName.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>


            <TextField
              select
              label="Sound"
              value={formData.sound}
              onChange={(e) => setFormData({ ...formData, sound: e.target.value })}
              fullWidth
              SelectProps={{
                native: true,
              }}
            >
              {Alarmlist.map((sound) => (
                <option key={sound.type} value={sound.type}>
                  {sound.type}
                </option>
              ))}
            </TextField>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.isActive}
                  onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                />
              }
              label="Active"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleCloseDialog}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={isSubmitting}
            sx={{
              position: 'relative',
              '& .MuiCircularProgress-root': {
                position: 'absolute',
                left: '50%',
                marginLeft: '-12px',
              }
            }}
          >
            {isSubmitting ? (
              <>
                <span style={{ visibility: 'hidden' }}>
                  {selectedEvent ? 'Update Event' : 'Add Event'}
                </span>
                <CircularProgress size={24} color="inherit" />
              </>
            ) : (
              selectedEvent ? 'Update Event' : 'Add Event'
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
} 